var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _rect, _rect2, _rect3, _rect4, _rect5, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 321,
    height: 261,
    viewBox: "0 0 321 261",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M104.693 4.25908C82.7701 13.0282 70.0483 35.5603 53.4546 52.4863C43.9385 62.2158 32.9058 70.2467 23.122 79.694C13.3383 89.1414 4.6846 100.461 1.71082 113.786C-3.94531 139.043 11.8217 163.712 15.9493 189.269C17.2637 197.432 17.4005 205.853 20.0233 213.68C22.099 219.874 25.6676 225.474 29.7952 230.486C46.5138 250.929 73.2718 262.579 99.4827 260.827C116.772 259.668 133.384 253.096 150.721 252.37C176.849 251.271 203.22 263.516 228.563 257.027C240.25 254.026 250.598 247.274 260.543 240.395C280.277 226.741 300.819 209.995 305.405 186.292C308.771 168.886 302.776 150.537 306.957 133.317C309.384 123.324 315.088 114.446 318.097 104.615C324.491 83.7695 317.663 60.055 303.097 43.9273C288.532 27.7995 267.156 18.8923 245.614 17.0016C231.489 15.7592 217.274 17.3258 203.095 17.0497C168.492 16.4134 140.598 -10.1041 104.693 4.25908Z",
    fill: "#D1EAF6",
    fillOpacity: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 165.5,
    cy: 134,
    r: 50,
    fill: "#5D5BF6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 74.9951,
    cy: 72.4951,
    r: 3.49515,
    fill: "#FCD933"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 76.6162,
    cy: 140.99,
    r: 4.66019,
    fill: "#F0633B"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5777,
    cy: 194.078,
    r: 4.07767,
    fill: "#FCD933"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 147.578,
    cy: 229.078,
    r: 4.07767,
    fill: "#04B2E3"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 197.908,
    cy: 198.408,
    r: 6.40777,
    fill: "#F0633B"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 260.694,
    cy: 178.272,
    r: 5.82524,
    fill: "#04B2E3"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 233.316,
    cy: 106.621,
    r: 4.07767,
    fill: "#5D5BF6"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 227.743,
    cy: 55.2427,
    r: 5.24272,
    fill: "#FCD933"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 118.743,
    cy: 65.2427,
    r: 5.24272,
    fill: "#5D5BF6"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 133.16,
    cy: 27.6602,
    r: 4.66019,
    fill: "#04B2E3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 57.7256,
    width: 28.328,
    height: 3.49515,
    rx: 1.74757,
    transform: "rotate(-44.1332 158.5 57.7256)",
    fill: "#FF2323"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 42.8301,
    y: 118.774,
    width: 25.4951,
    height: 3.49515,
    rx: 1.74757,
    transform: "rotate(-44.1332 42.8301 118.774)",
    fill: "#FF2323"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 94.0918,
    y: 222.821,
    width: 18.9977,
    height: 3.49515,
    rx: 1.74757,
    transform: "rotate(-44.1332 94.0918 222.821)",
    fill: "#5D5BF6"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 222.5,
    y: 226.127,
    width: 28.9047,
    height: 3.49515,
    rx: 1.74757,
    transform: "rotate(-44.1332 222.5 226.127)",
    fill: "#FF2323"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 269.5,
    y: 118.563,
    width: 22.3498,
    height: 3.49515,
    rx: 1.74757,
    transform: "rotate(-44.1332 269.5 118.563)",
    fill: "#F0633B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.5 132.5L159.5 147L186 121",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.48a815b84f3f2a7c257d328f21236c04.svg";
export { ForwardRef as ReactComponent };